import { motion } from "framer-motion";
import { Gift, ArrowRight, Sparkles } from "lucide-react";
import { waLink } from "../data/site";
import { Reveal } from "./Reveal";

export const PromoBanner = () => (
  <section className="relative py-16 sm:py-20 overflow-hidden" data-testid="promo-section">
    <div className="absolute inset-0 bg-[#0B261E]" />
    <div className="absolute -top-24 left-1/3 w-[420px] h-[420px] rounded-full bg-[#A3E635]/10 blur-[110px]" />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="relative rounded-3xl border border-[#A3E635]/30 bg-[#04120E]/70 backdrop-blur-md p-8 sm:p-12 overflow-hidden">
          <div className="absolute top-0 right-0 w-56 h-56 bg-[#00E676]/15 blur-[80px] rounded-full" />
          <p className="inline-flex items-center gap-2 text-xs font-mono2 uppercase tracking-[0.25em] text-[#A3E635] mb-5">
            <Sparkles size={13} /> Green Friday · só até 30/11
          </p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight max-w-2xl">
            Cadastre sua conta de luz e <span className="text-[#A3E635]">ganhe R$ 50 no Pix</span>
          </h2>
          <p className="mt-4 max-w-xl text-sm sm:text-base text-emerald-100/70 leading-relaxed">
            Quando o seu cadastro for validado, o Pix de <strong className="text-white">R$ 50,00</strong> cai na hora.
            E você ainda tem <strong className="text-[#00E676]">até 15% de desconto</strong> na conta de luz, sem obra e sem investimento.
          </p>
          <motion.a
            whileHover={{ scale: 1.04 }}
            whileTap={{ scale: 0.97 }}
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="promo-pix-cta"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#A3E635] hover:bg-[#bef264] text-[#04120E] font-bold px-7 py-4 shadow-[0_0_26px_rgba(163,230,53,0.4)] transition-colors duration-300"
          >
            <Gift size={18} /> Cadastrar e ganhar R$ 50 <ArrowRight size={16} />
          </motion.a>
          <p className="mt-6 text-[11px] leading-relaxed text-emerald-100/40 max-w-2xl">
            Válido para contas de luz de: Alagoas, Bahia, Ceará, Goiás, Minas Gerais, Mato Grosso do Sul, Mato Grosso,
            Pernambuco, Piauí, Paraná, Rio Grande do Norte, Rio de Janeiro, São Paulo e Tocantins. Somente para cadastro
            validado. Sujeito a regras e condições. Válido até 30/11/2026.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
